import type { FC, ReactNode } from 'react';
import { withGuestGuard } from 'src/modules/auth/hocs/with-guest-guard';

import Seo from '@/components/Seo';

import Header from '../clean/components/Header';
import { LayoutRoot } from '../clean/components/LayoutRoot';

interface LayoutProps {
  children: ReactNode;
  enableBackground?: boolean;
}

export const OnboardingLayout: FC<LayoutProps> = withGuestGuard(
  ({ children, enableBackground = false }: LayoutProps) => {
    return (
      <LayoutRoot enableBackground={enableBackground}>
        <Seo
          title="Sign in to Fuul"
          description="Welcome to Fuul! Sign in to your account or set up a new profile in a few seconds."
          image="/assets/backgrounds/fuul-cover.webp"
        />
        <Header />
        <main className="tw:flex tw:flex-col tw:justify-center tw:flex-1">
          <div className="tw:container tw:max-w-screen-lg tw:mx-auto tw:px-6">{children}</div>
        </main>
      </LayoutRoot>
    );
  },
);
